import React, { useContext, useMemo } from 'react'

import { ActionDropdown, Avatar, IconButton, ToolTip } from '@driftt/tide-core'
import { access } from '@driftt/traffic-control'

import UserSummaryTooltip from 'components/UserSummaryTooltip'
import { CurrentUserContext } from 'context/currentUserContext'
import { OrgUsersContext } from 'context/orgUsersContext'
import { Comment } from 'modules/accountActivity/domain'
import { timeSinceUpdated } from 'utils/timeStamp'
import { getDisplayName } from 'utils/user'

import DeletedComment from './DeletedComment'

import styles from './styles.module.css'

const renderNode = (node: any, orgUsersById: any) => {
  if (node.type === 'mention') {
    return (
      <UserSummaryTooltip userId={node.mentionUserId}>
        <span className={styles.mention}>{getDisplayName(orgUsersById[node.mentionUserId])}</span>
      </UserSummaryTooltip>
    )
  } else {
    return node.text
  }
}

const CommentBody: React.FC<{
  comment: Comment
  replyAction: () => void
  onCommentDeleted: (comment: Comment) => void
}> = ({ comment, replyAction, onCommentDeleted }) => {
  const currentUser = useContext(CurrentUserContext)
  const orgUsersById = useContext(OrgUsersContext)

  const content = useMemo(() => {
    try {
      return JSON.parse(comment.content).map((node: any, i: number) => (
        <p key={i}>{node.children.map((node: any) => renderNode(node, orgUsersById))}</p>
      ))
    } catch (e) {
      return comment.content
    }
  }, [comment.content, orgUsersById])

  return comment.deleted ? (
    <DeletedComment />
  ) : (
    <div className={styles.commentBody}>
      <Avatar user={orgUsersById[comment.userId]} />
      <div>
        <div className={styles.commentContent}>
          <div className={styles.commentContentHeader}>{orgUsersById[comment.userId]?.name}</div>
          {content}
        </div>
        <div className={styles.commentActions}>
          <span className={styles.replyAction} onClick={replyAction}>
            Reply
          </span>
          {' · ' + timeSinceUpdated(comment.createdAt)}
        </div>
      </div>
      {(comment.userId === currentUser?.id || access.isAdmin()) && (
        <ActionDropdown
          tethered
          className={styles.moreActionsDropdown}
          trigger={
            <ToolTip flow="up" component={'More actions'}>
              <IconButton icon="meatballs" />
            </ToolTip>
          }
          align="left"
          actions={[
            {
              key: 'delete',
              label: 'Delete comment',
              action: () => onCommentDeleted(comment)
            }
          ]}
        />
      )}
    </div>
  )
}

export default CommentBody
